import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { User } from 'src/app/auth/models/user';
import { CommonHandler } from '../handlers/common-handler';
import { CookieHandler } from '../handlers/cookie-handler';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { StorageHandler } from '../handlers/storage-handler';

@Injectable()
export class GlobalService {
  readonly COOKIE_NAME: string = 'asterisk_cookie';
  readonly ACCESS_COOKIE: string = 'asterisk_access_cookie';
  public toolName = 'Team Asterisk';
  public scenarioName: string = "";
  public headerLogo = './assets/images/asterisk-header-new.png';
  private _user: User;
  private _token: any;
  private _globalParams: any;
  private _showTeamLogos: boolean;
  public ssoValidating = false;
  public expiredCounter = 0.0;
  public mapActiveKey = false;

  private globalParameter = new BehaviorSubject<Object>({});
  selectedGlobalParamater = this.globalParameter.asObservable();

  private closeCycleStatus = new BehaviorSubject<Object>({});
  checkCloseCycleStatus = this.closeCycleStatus.asObservable();

  private syncSalesScreenStatus = new BehaviorSubject<Object>({});
  checkSyncSalesScreenStatus = this.syncSalesScreenStatus.asObservable();

  constructor(private titleService: Title, private cookieHandler: CookieHandler, private storageHandler: StorageHandler) {
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public createUserSession(user: User, token: any, expiresOn: any, globalParams: any): void {
    this.expiredCounter = 0;
    this._user = CommonHandler.getCopy(user);
    this._token = CommonHandler.getCopy(token);
    this._globalParams = CommonHandler.getCopy(globalParams);
    const cookie = { token, globalParams };
    const accessCookie = { user };

    this.cookieHandler.createLSCookie(this.COOKIE_NAME, JSON.stringify(cookie), expiresOn);
    this.cookieHandler.createLSCookie(this.ACCESS_COOKIE, JSON.stringify(accessCookie), expiresOn);
  }


  updateGlobalParamater(event) {
    this.globalParameter.next(event);
  }

  updateCloseCycleStatus(event) {
    this.closeCycleStatus.next(event);
  }

  updateSyncSalesScreenStatus(event) {
    this.syncSalesScreenStatus.next(event);
  }


  public deleteUserSession(): void {
    this.cookieHandler.deleteLSCookie(this.COOKIE_NAME);
    this.cookieHandler.deleteLSCookie(this.ACCESS_COOKIE);
    this._user = undefined;
    this._token = undefined;
    this.storageHandler.clearStorages();
    // this._globalParams = undefined;
  }

  public get user(): User {
    if (!this._user) {
      const cookie = this.cookieHandler.readLSCookie(this.ACCESS_COOKIE);
      if (cookie) {
        this._user = JSON.parse(cookie).user;
      }
    }
    return this._user;
  }

  public get token(): string {
    const cookie = this.cookieHandler.readLSCookie(this.COOKIE_NAME);
    if (cookie) {
      this._token = JSON.parse(cookie).token;
    } else {
      this._token = undefined;
    }
    return this._token;
  }

  public get globalParams(): any {
    if (!this._globalParams) {
      const cookie = this.cookieHandler.readLSCookie(this.COOKIE_NAME);
      if (cookie) {
        this._globalParams = JSON.parse(cookie).globalParams;
      }
    }
    return this._globalParams;
  }

  public get showTeamLogos(): boolean {
    this._showTeamLogos = environment.showTeamLogos || false;
    return this._showTeamLogos;
  }

  public get authenticated(): boolean {
    return this.user != null && this.token != null;
  }

  public setSessionStorageItem(key: string, value: any) {
    sessionStorage.setItem(key, value);
  }

  public deleteSessionStorageItem(key: string) {
    sessionStorage.removeItem(key);
  }

  public deleteLocalStorageItem(key: string) {
    localStorage.removeItem(key);
  }

  public getSessionStorageItem(key: string): any {
    return sessionStorage.getItem(key);
  }

  private _clearStorages(): void {
    sessionStorage.clear();
    localStorage.clear();
  }

  public getLocalStorageItem(key: string): any {
    return localStorage.getItem(key);
  }

  public setLocalStorageItem(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public setCycleName(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public getCycleName(key: string) {
    return localStorage.getItem(key);
  }

  public setToolIcon(route: string) {
    const role = this.user.roles.find(role => role.role_privilege_route === route);
    this.setTitle(role.label);
    this.toolName = role.label;
    this.headerLogo = role.image_path;
  }

  public hasRole(userRole: string): boolean {
    const roleIndex = this.user.roles.findIndex(role => role.role_name.toLowerCase() === userRole.toLowerCase());
    if (roleIndex > -1) {
      return true;
    }
    return false;
  }

  public isAdmin(): boolean {
    return this.user.roles.some(r => r.role_name === 'Admin');
  }

  public create_UUID() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  public setProcessStatus(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public getProcessStatus(key: string) {
    return localStorage.getItem(key);
  }

  public deleteProcessStatus(key: string) {
    localStorage.removeItem(key);
  }
}
